import { render } from "./header.vue?vue&type=template&id=ad6497d4"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__